<template>
  <div class="webinar-admin-buttons">
    <div
      :class="['webinar-admin-button', { 'webinar-admin-button-visible': button.visibility }]"
      v-for="button in buttons" :key="button.id"
      :title="button.visibility ? t('public.hideButton') : t('public.showButton')"
      @click="changeVisibility(button)">
      <icon-eye v-if="button.visibility"/>
      <icon-eye-slash v-else/>
      &nbsp;
      {{ button.label }}
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import IconEye from '@/vue/icons/IconEye.vue'
import IconEyeSlash from '@/vue/icons/IconEyeSlash.vue'
import periodic from '@/scripts/periodic'
import { request } from '@/scripts/combinedRequest'
import { Button } from '@/types/webinar.d'

export default defineComponent({
  name: 'AdminButtons',
  components: { IconEyeSlash, IconEye },
  props: {
    scheduleId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const buttons = ref<Button[]>([])

    onBeforeUnmount(periodic(1000, async () => {
      buttons.value = await request<Button[]>('buttons')
    }))

    return {
      t,
      buttons,
      async changeVisibility(button: Button) {
        // eslint-disable-next-line no-param-reassign
        button.visibility = !button.visibility
        await axios.post(`/buttons/${props.scheduleId}/visibility`, {
          id: button.id,
          visibility: button.visibility,
        })
      },
    }
  },
})
</script>

<style lang="stylus">
.webinar-admin-buttons
  display flex
  flex-wrap wrap
  align-items flex-start

  .webinar-admin-button
    background var(--button-color)
    color var(--button-text-color)
    text-decoration none
    text-transform uppercase
    white-space nowrap
    text-overflow ellipsis
    max-width 100%
    font-weight bold
    padding 8px 15px
    border-radius 3px
    margin 0 10px 10px 0
    opacity .3
    transition .2s
    cursor pointer

    &.webinar-admin-button-visible
      opacity 1

    &:hover
    &.webinar-admin-button-visible:hover
      opacity .7
</style>
